import { PaymentProvider } from "../../../../../services/PaymentSystem";

/**
 * Terminal networks (driver balance top-up): configured on the
 * "Terminals" page, never offered as an acquiring provider.
 */
export const TERMINAL_PROVIDERS: PaymentProvider[] = [
	PaymentProvider.EASYPAY,
	PaymentProvider.OTV,
];

/** Acquiring providers for customer / executor payment systems. */
export const ACQUIRING_PROVIDERS: PaymentProvider[] = Object.values(
	PaymentProvider,
).filter((provider) => !TERMINAL_PROVIDERS.includes(provider));
